import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import NewsletterSubscribe from './subscribe';
import NewsletterSignup from './signup';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        if (!props.lists && props.logged_in){
            props.getLists();
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.logged_in != this.props.logged_in) {
            if (nextProps.logged_in) {
                this.props.getLists();
            }

            return true;
        }

        if (nextProps.lists != this.props.lists) {
            return true;
        }

        return false;
    }

    render({ logged_in, lists }) {
        if (!logged_in) {
            return (
                <newsletter>
                    <NewsletterSignup />
                </newsletter>
            );
        } else if (logged_in && lists) {
            return (
                <newsletter>
                    <NewsletterSubscribe />
                </newsletter>
            );
        }

        return (<newsletter />);
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    lists: state['mail-lists'] && state['mail-lists'].lists,
});

const mapDispatchToProps = (dispatch) => ({
    getLists: () => dispatch({ type: 'mail-lists:get' }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);